import {
  Box,
  Table,
  Tag,
  Text,
  VStack,
} from "@chakra-ui/react";

import AgentServiceTimePerServiceLineGraph from "../../charts/daily/AgentServiceTimePerServiceLineGraph";

import { formatPercent, formatTime } from "../../../../store/helpers";

const AgentServicesTableRows = ({ data }) => {
  return (
    <>
      {data.map((agentData, index) => {
        const { agentName, serviceName } = agentData;
        return agentData.sum ? (
          <Box key={index} mt="20px" mb="20px">
            <Table.Root className="stripedTable" size="sm">
              <Table.Header>
                <Table.Row>
                  <Table.ColumnHeader>#</Table.ColumnHeader>
                  <Table.ColumnHeader>Agent Name</Table.ColumnHeader>
                  <Table.ColumnHeader borderRight="1px solid #dadce0">Total Service Time</Table.ColumnHeader>
                  <Table.ColumnHeader borderRight="1px solid #dadce0">Average</Table.ColumnHeader>
                  <Table.ColumnHeader>Min</Table.ColumnHeader>
                  <Table.ColumnHeader>Max</Table.ColumnHeader>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>{index + 1}</Table.Cell>
                  <Table.Cell>{agentData.agentName}</Table.Cell>
                  <Table.Cell borderRight="1px solid #dadce0">
                    <VStack gap="2px" align="start">
                      <Text color={"var(--green)"}>
                        {formatTime(agentData.sum)}
                      </Text>
                      <Text
                        color="gray.500"
                        fontWeight="semibold"
                        fontSize="xs"
                        textTransform="uppercase"
                      >
                        ({formatPercent(agentData.totalPct)})
                      </Text>
                    </VStack>
                  </Table.Cell>
                  <Table.Cell borderRight="1px solid #dadce0">
                    {formatTime(agentData.average)}
                  </Table.Cell>
                  <Table.Cell>{formatTime(agentData.min)}</Table.Cell>
                  <Table.Cell>{formatTime(agentData.max)}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell colSpan={6}>
                    <Box mt="20px" mb="20px">
                      <AgentServiceTimePerServiceLineGraph
                        title={`${agentName}: ${serviceName}, Hour by Hour Comparison`}
                        chart={agentData.chart}
                        height={"200px"}
                      />
                    </Box>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table.Root>
          </Box>
        ) : (
          <Text key={index} fontWeight={500}>
            No data for agent: {agentData.agentName}
          </Text>
        );
      })}
    </>
  );
};

const AgentServiceTimePerServiceTable = ({
  serviceData,
  branchId,
  branchName,
  
  branchIndex,
  index,
}) => {
  const { totalServiceTime, agentsData, serviceName } = serviceData;

  const title = `${branchIndex + 1}.${
    index + 1
  }. ${serviceName}`;
  

  return (
    <Box>
      <h3>{title}</h3>
      {!totalServiceTime && (
        <Text fontSize="sm">No data available for this report</Text>
      )}
      <Tag.Root>
        <Tag.Label className="branchTag">{branchName} Branch</Tag.Label>
      </Tag.Root>
      {totalServiceTime ? (
        <>
          <AgentServicesTableRows data={agentsData} />
        </>
      ) : (
        <></>
      )}
    </Box>
  );
};

export default AgentServiceTimePerServiceTable;
